import { observer } from "mobx-react-lite";
import { ShareSheetCollectionPermissionRow } from "@/components/modal/share-sheet/share-sheet-permission-row/share-sheet-collection-permission-row";
import {
  SyncModelPermissionEntry,
  SyncModelPermissionEntryCollection,
  SyncModelPermissionEntryEmail,
  SyncModelPermissionEntryGuestAccount,
  SyncModelPermissionEntrySpaceAccount,
  SyncModelPermissionEntryStatus,
  SyncModelPermissionEntryWithStatus,
} from "@/domains/sync-scopes/types";
import { ShareSheetSpaceAccountPermissionRow } from "@/components/modal/share-sheet/share-sheet-permission-row/share-sheet-space-account-permission-row";
import { ShareSheetEmailPermissionRow } from "@/components/modal/share-sheet/share-sheet-permission-row/share-sheet-email-permission-row";
import { ShareSheetModalStore } from "@/components/modal/share-sheet/share-sheet-modal-store";
import { noop } from "lodash-es";

interface ShareSheetPermissionRowProps {
  permission: SyncModelPermissionEntryWithStatus;
  isUnsharing: boolean;
  isGuestMode: boolean;
  canUpdateAccess: boolean;
  canRevokeAccess: boolean;
  handleRevokeAccess: (modelAccessData: SyncModelPermissionEntry) => void;
  handleUpdateAccess: (modelAccessData: SyncModelPermissionEntry) => void;
  handleCancelOperation: (syncOperationId: string) => void;
  shareSheetModalStore: ShareSheetModalStore;
}

export const ShareSheetPermissionRow = observer<ShareSheetPermissionRowProps>(
  ({
    permission,
    isUnsharing,
    isGuestMode,
    canUpdateAccess,
    canRevokeAccess,
    handleRevokeAccess,
    handleUpdateAccess,
    handleCancelOperation,
    shareSheetModalStore,
  }) => {
    switch (permission.scope_kind) {
      case "COLLECTION_SCOPE":
        return (
          <ShareSheetCollectionPermissionRow
            permission={
              permission as SyncModelPermissionEntryCollection & SyncModelPermissionEntryStatus
            }
            isUnsharing={isUnsharing}
            canUpdateAccess={!isGuestMode && canUpdateAccess}
            canRevokeAccess={!isGuestMode && canRevokeAccess}
            handleRevokeAccess={handleRevokeAccess}
            handleUpdateAccess={handleUpdateAccess}
            handleCancelOperation={handleCancelOperation}
          />
        );
      case "SPACE_ACCOUNT_SCOPE":
        return (
          <ShareSheetSpaceAccountPermissionRow
            permission={
              permission as SyncModelPermissionEntrySpaceAccount & SyncModelPermissionEntryStatus
            }
            isUnsharing={isUnsharing}
            canUpdateAccess={!isGuestMode && canUpdateAccess}
            canRevokeAccess={!isGuestMode && canRevokeAccess}
            handleRevokeAccess={handleRevokeAccess}
            handleUpdateAccess={handleUpdateAccess}
            handleCancelOperation={handleCancelOperation}
            shareSheetModalStore={shareSheetModalStore}
          />
        );
      case "EMAIL_SCOPE":
        return (
          <ShareSheetEmailPermissionRow
            permission={
              permission as SyncModelPermissionEntryEmail & SyncModelPermissionEntryStatus
            }
            isUnsharing={isUnsharing}
            handleRevokeAccess={noop}
            handleUpdateAccess={noop}
            handleCancelOperation={handleCancelOperation}
          />
        );
      case "GUEST_ACCOUNT_SCOPE":
        return (
          <ShareSheetEmailPermissionRow
            permission={
              permission as SyncModelPermissionEntryGuestAccount & SyncModelPermissionEntryStatus
            }
            isUnsharing={isUnsharing}
            handleRevokeAccess={handleRevokeAccess}
            handleUpdateAccess={handleUpdateAccess}
            handleCancelOperation={handleCancelOperation}
          />
        );
      default:
        return null;
    }
  }
);
